module.exports = "/static/assets/651275fc77d16a2586317749c28bb799.png";